// Brand palette + type scale used only by this page's Figma redesign
// (node-id 42908:536) — not yet part of the shared ThemeContext design tokens.
export const PRIMARY_GREEN = '#033634';
export const DARKER_GREEN = '#03211F';
export const PRIMARY_TEAL = '#0DC6BF';
export const MID_TEAL = '#93E3E0';
export const BRIGHT_HONEY_DEW = '#4EFE8F';
export const BRIGHT_HONEY_DEW_HOVER = '#3DEB7D';
export const PAGE_BACKGROUND = '#FAFAFA';
export const NEUTRAL_BORDER = '#D0D0D0';
export const NEUTRAL_300 = '#989898';
export const NEUTRAL_600 = '#666666';
export const WHITE = '#FFFFFF';
export const BLACK = '#000000';

export const FONT_FAMILY = "'Plus Jakarta Sans', sans-serif";
